/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
import { useContext, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { MetadataContext } from '../MetadataContext';
import { SettingsContext } from '../SettingsContext';
import { useTheme } from 'styled-components';

function AboutSettings() {
    const theme = useTheme() as any;
    const sectionBorder = `1px solid ${theme?.colors?.ctext || '#ccc'}`;
    const metadataContext = useContext<any>(MetadataContext);
    const settingsContext = useContext(SettingsContext);

    useEffect(() => {
        settingsContext.setIsDirty(false);
    }, [settingsContext]);

    return (
        <div>
            <div className="mb-4" style={{ borderBottom: sectionBorder, paddingBottom: '0.75rem' }}>
                <h3 className="mb-1">About</h3>
                <div className="text-muted">Version information.</div>
            </div>
            <Card className="mb-4">
                <Card.Header>Version Information</Card.Header>
                <Card.Body>
                    <div className="mb-2"><strong>Code Version:</strong> {metadataContext.appVersion}</div>
                    <div className="mb-2"><strong>Data Schema:</strong> {metadataContext.schemaVersion}</div>
                    <div><strong>Local Data Schema:</strong> {metadataContext.localSchemaVersion || 'unknown'}</div>
                </Card.Body>
            </Card>
        </div>
    );
}

export default AboutSettings;

